export interface InitialProps {
    sellerName: string;
    resellingPrograms: ResellingPrograms;
    isOpenSubscriptionDrawer: boolean;
}

export enum ProgramSlug {
    Microsoft365 = 'microsoft_365',
}

export enum BillingCycle {
    MONTHLY = 'MONTHLY',
    YEARLY = 'YEARLY',
}

export enum BillingTerm {
    MONTH = 'MONTH',
    YEAR = 'YEAR',
}

export enum SubscriptionTier {
    Basic = 'business_basic',
    Standard = 'business_standard',
    Premium = 'business_premium',
    Apps = 'apps_for_business',
}

interface RegularPrice {
    amountInCents: number;
    monthlyAmountInCents: number;
}

interface DiscountedPrice {
    discountedAmountInCents: number;
    discountedMonthlyAmountInCents: number;
}

interface FormattedPrice {
    amountMonthly: number;
    amountYearly: number;
    discountedAmountMonthly: number;
    discountedAmountYearly: number;
}

interface Price extends RegularPrice, DiscountedPrice {
    currency: string;
}

export interface ResellingProduct {
    id: string;
    country: string;
    name: SubscriptionTier;
    billingCycle: BillingCycle;
    billingTerm: BillingTerm;
    price: Price;
    minQuantity: number;
    maxQuantity: number;
    totalQuantity: number;
}

export interface ResellingDetails {
    id: string;
    slug: ProgramSlug;
    sellerId: number;
    countries: string[];
    discountPercent: number;
    availableDiscountedSalesForSeller: number;
}

type CountryCode = string;

export interface ResellingPrograms extends ResellingDetails {
    products: Record<CountryCode, Record<BillingCycle, ResellingProduct[]>>;
}

export interface PricingDetails {
    productId: ResellingProduct['id'] | null;
    tierName: ResellingProduct['name'];
    billingCycle: BillingCycle;
    billingTerm: BillingTerm;
    minQuantity: ResellingProduct['minQuantity'];
    maxQuantity: ResellingProduct['maxQuantity'];
    totalQuantity: ResellingProduct['totalQuantity'];
    price: (ResellingProduct['price'] & FormattedPrice) | null;
}
